import { useCallback } from 'react';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';

type Args = {
  paramKey: string;
  defaultGroupBy?: string;
  groupableColumnIds?: string[];
};

const useGroupByParam = ({
  paramKey,
  defaultGroupBy,
  groupableColumnIds,
}: Args) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const requestedGroupBy = searchParams.get(paramKey) || defaultGroupBy || null;
  const isRequestedGroupable =
    !groupableColumnIds ||
    !requestedGroupBy ||
    groupableColumnIds.includes(requestedGroupBy);
  const groupBy = isRequestedGroupable
    ? requestedGroupBy
    : defaultGroupBy ?? null;

  const onGroupByChange = useCallback(
    (next: string | null) => {
      setSearchParams((prev) => {
        const resolved = next || defaultGroupBy;
        if (!resolved || resolved === defaultGroupBy) {
          prev.delete(paramKey);
        } else {
          prev.set(paramKey, resolved);
        }
        return prev;
      });
    },
    [setSearchParams, paramKey, defaultGroupBy],
  );

  return { groupBy, onGroupByChange };
};

export default useGroupByParam;
